AFRAME.registerComponent('data-interval-control', {
    schema: {
        width: { type: 'number', default: 5.8 },
        height: { type: 'number', default: 0.95 },
        depth: { type: 'number', default: 0.1 }
    },

    init: function () {
        this.selectedButton = null;
        this.scene = document.querySelector('a-scene');
        this.createButtons();
    },

    createButtons: function () {
        const buttonLabels = ['1D', '5D', '1M', '6M', 'YTD', '1Y', '5Y', 'All'];

        const buttonsConfig = [
            { label: '1D', disabled: false, position: '-1.5 1.5 0' },
            { label: '5D', disabled: false, position: '-1.5 0 0' },
            { label: '1M', disabled: false, position: '0 1.5 0' },
            { label: '6M', disabled: true, position: '-1.5 -1.5 0' },
            { label: 'YTD', disabled: true, position: '0 0 0' },
            { label: '1Y', disabled: true, position: '1.5 1.5 0' },
            { label: '5Y', disabled: true, position: '0 -1.5 0' },
            { label: 'All', disabled: true, position: '1.5 0 0' },
        ];

        const buttonWidth = 1.2;
        const buttonHeight = 1.2

        this.buttons = [];

        buttonsConfig.forEach((button, index) => {
            this.createMenuButton(this.el, button.label, button.label, button.position, buttonWidth, buttonHeight, button.disabled);
        });

        const dataCacheButton = getCacheItem('data-interval');
        console.log(`[data-interval-control] Data cache button:`, dataCacheButton);
        if (dataCacheButton != null) {
            this.selectButton(this.buttons[buttonLabels.indexOf(dataCacheButton)]);
        } else {
            this.selectButton(this.buttons[0]);
        }
    },

    createMenuButton: function (parent, label, action, position, buttonWidth, buttonHeight, disabled = false) {
        const button = document.createElement('a-entity');
        button.setAttribute('ui-button', {
            label: label,
            type: 'rounded-box',
            width: buttonWidth,
            height: buttonHeight,
            depth: 0.2,
            colorScheme: 'tetriary',
            autosize: false,
            isSelectable: true,
            disabled: disabled,
            radius: 0.2,
            preferredFontSize: 0.5,
            // isAutoRotationContent: true
            contentRotation: 45
        });
        button.setAttribute('position', position);
        button.setAttribute('data-raycastable', '');
        button.setAttribute('data-label', label);

        button.addEventListener('click', () => {
            if (!button.getAttribute('ui-button').disabled) {
                this.handleMenuAction(action, button);

                if (window.gtag) gtag('event', `VR_CenterPanel_TimeLine`, { period: label });
            }
        });

        parent.appendChild(button);
        this.buttons.push(button);
    },

    handleMenuAction: function (action, button) {
        if (button !== this.selectedButton) {
            this.selectButton(button);
            setCacheItem('data-interval', action, 24 * 60);
            console.log(
                `[data-interval-control] Selected button '${button.getAttribute('data-label')}', emitting event with interval:`,
                action
            );
            this.scene.emit('data-interval', { interval: action });

            const cameraRig = document.querySelector('#cameraRig');
            if (cameraRig) {
                cameraRig.emit('update-billboards');
            }
        }
    },

    selectButton: function (button) {
        const newLabel = button.getAttribute('data-label');

        if (this.selectedButton && this.selectedButton !== button) {
            const oldLabel = this.selectedButton.getAttribute('data-label');
            console.log(`[data-interval-control] Deselecting button '${oldLabel}', reverting to default color`);
            this.selectedButton.setAttribute('ui-button', 'selected', false);
            this.selectedButton.setAttribute('scale', '1 1 1');
        }

        this.selectedButton = button;
        button.setAttribute('ui-button', 'selected', true);
        button.setAttribute('scale', '1.05 1.05 1.05');
    }
});
